// extracted by mini-css-extract-plugin
module.exports = {"links":"documents_links__spksU","link":"documents_link__h_DUL"};